import type { FC, PropsWithChildren } from 'react';

import { type BleedProps, bleedRecipe } from './Bleed.css';
import { getClassNames } from '../../util/css';

type Props = BleedProps & { className?: never };

const sparkyClassName = 'sparky-bleed';

export const Bleed: FC<PropsWithChildren<Props>> = ({
  children,
  horizontal,
  vertical,
  top,
  bottom,
  left,
  right,
  className = '',
}) => {
  const classNames = getClassNames(
    sparkyClassName,
    bleedRecipe({ horizontal, vertical, top, bottom, left, right } as Parameters<typeof bleedRecipe>[0]),
    className,
  );

  return <div className={classNames}>{children}</div>;
};

Bleed.toString = () => `.${sparkyClassName}`;
Bleed.displayName = 'Bleed';
